import axiosInstance from './axios'
let http = {}
// export default axiosInstance
http.post = function(url, data = {}) {
  return new Promise((resolve, reject) => {
    axiosInstance.post(url, data).then(
      response => {
        resolve(response)
      },
      err => {
        reject(err)
      }
    )
  })
}
/**
 * 封装get请求
 * @param url
 * @param data
 * @returns {Promise}
 */
http.get = function(url) {
  return new Promise((resolve, reject) => {
    axiosInstance.get(url).then(
      response => {
        resolve(response)
      },
      err => {
        reject(err)
      }
    )
  })
}
export default http
